import { useQuery, useMutation } from "@tanstack/react-query";
import { apiDelete, apiGet, apiPost, apiUpdate } from "api/api-intake";

// ✅ Generic Fetch Hook
export const useFetch = (key, url, params = {}) => {
  return useQuery({
    queryKey: [key, params], // ✅ React Query will detect changes
    queryFn: () => apiGet(url, params),
    keepPreviousData: true, // Prevents unnecessary loading states during pagination
    staleTime: 300000, // Cache data for 5 minutes
    cacheTime: 10 * 60 * 1000,
    retry: 2,
  });
};

export const useFetchProducts = (key, url, params = {}) => {
  return useQuery({
    queryKey: [key, params],
    queryFn: () => apiGet(url, params),
    enabled: !!key, // 👈 this line will prevent API call when key is null/false
    keepPreviousData: true,
    staleTime: 300000,
    cacheTime: 10 * 60 * 1000,
    retry: 2,
  });
};

export const usePost = (key, url) => {
  return useMutation({
    mutationFn: (data) => {
      return apiPost(url, data);
    },
    onError: (error) => {
      console.error(`${key} error:`, error);
    },
  });
};

export const useUpdate = (key, url) => {
  return useMutation({
    mutationFn: ({ params, data }) => {
      // Construct query parameters
      const queryParams = new URLSearchParams(params).toString();
      // Append query parameters to the URL
      const fullUrl = `${url}?${queryParams}`;
      // Perform the API update
      return apiUpdate(fullUrl, data);
    },
    onError: (error) => {
      console.error(`${key} update error:`, error);
    },
  });
};


export const useDelete = (key, url) => {
  return useMutation({
    mutationFn: (params) => {
      const queryParams = new URLSearchParams(params).toString();
      // Append query parameters to the URL
      const fullUrl = `${url}?${queryParams}`;   
         return apiDelete(fullUrl); // ✅ Correct URL format
    },
    onError: (error) => {
      console.error(`${key} delete error:`, error);
    },
  });
};
